import { FLAT_RATE_PLANS, flatRatePlanNames } from "@common/flatRateBilling";
import { usePlanManagement } from "@components/billing/PlanManagement/PlanManagementContext";
import { useSettings } from "@components/settings/SettingsProvider";
import { Button } from "@design-system/Button/Button";
import { PlainModal, StandardModalHeader } from "@design-system/Modal/Modal";
import { HStack } from "@design-system/HStack/HStack";
import { useCallback } from "react";

interface Props {
    show: boolean;
    onHide: () => void;
    plan: FLAT_RATE_PLANS;
    text: React.ReactNode;
    description?: React.ReactNode;
}

export const FeatureUpgradeModal: React.FC<Props> = ({
    show,
    onHide,
    plan,
    text,
    description,
}) => {
    const { upgrade } = usePlanManagement();
    const { open: openSettings } = useSettings();

    const handleUpgrade = useCallback(() => {
        onHide();
        upgrade(plan, false);
    }, [onHide, plan, upgrade]);

    const handleViewPlans = useCallback(() => {
        onHide();
        openSettings(["plans"]);
    }, [onHide, openSettings]);

    return (
        <PlainModal show={show} onHide={onHide} size="md">
            <StandardModalHeader>
                <div className="mb-0">{text}</div>
            </StandardModalHeader>

            {description && <div>{description}</div>}

            <HStack
                as="footer"
                justify="end"
                gap={12}
                className="modal-footer mt-4"
            >
                <Button variant="primary" onClick={handleViewPlans} size="xl">
                    View plans
                </Button>
                <Button
                    variant="tertiary"
                    onClick={handleUpgrade}
                    size="xl"
                    data-testid="feature-upgrade-button"
                >
                    Upgrade to {flatRatePlanNames[plan]}
                </Button>
            </HStack>
        </PlainModal>
    );
};
